export default "__VITE_ASSET__DcSHRlEH__"